import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// токен в памяти
let accessTokenMemory = null;
let refreshTimer = null;
let hasAuthenticatedSession = false;

// Таймер для автоматического обновления
function scheduleRefresh(token) {
  if (!token) return;

  try {
    const decoded = jwtDecode(token);
    const expiresAt = decoded.exp * 1000; // timestamp в мс
    const now = Date.now();
    const timeout = expiresAt - now;

    if (refreshTimer) clearTimeout(refreshTimer);

    if (timeout > 0) {
      refreshTimer = setTimeout(async () => {
        await refreshToken();
      }, timeout);
    }
  } catch (e) {
    console.error("Ошибка декодирования токена", e);
  }
}

let refreshPromise = null;

function isLoginPage() {
  return /^\/login\/?$/.test(window.location.pathname);
}

function shouldNotifySessionExpired() {
  return (hasAuthenticatedSession || accessTokenMemory) && !isLoginPage();
}

// Обновление токена через refreshToken в куки
export async function refreshToken() {
  if (isLoginPage()) return null;

  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API_BASE_URL}/api/auth/refresh`, {}, { withCredentials: true })
      .then(res => {
        const newToken = res.data.token;
        if (!newToken) throw new Error("Нет нового токена");

        accessTokenMemory = newToken;
        hasAuthenticatedSession = true;
        scheduleRefresh(newToken);

        return newToken;
      })
      .catch(async () => {
        const notify = shouldNotifySessionExpired();

        if (notify) {
          try {
            await api.post("/api/auth/logout");
          } catch (e) {
            console.error("Ошибка выхода", e);
          }

          alert("Сессия истекла. Пожалуйста, войдите снова.");

          if (!isLoginPage()) {
            window.location.href = "/login";
          }
        }

        localStorage.clear();
        accessTokenMemory = null;
        hasAuthenticatedSession = false;

        return null;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

// добавляем токен в каждый запрос
// api.interceptors.request.use(config => {
//   if (accessTokenMemory) config.headers.Authorization = `Bearer ${accessTokenMemory}`;
//   return config;
// });

api.interceptors.request.use(config => {
  if (accessTokenMemory) {
    config.headers.Authorization = `Bearer ${accessTokenMemory}`;
    hasAuthenticatedSession = true;
  }
  return config;
});

// ловим новый токен от сервера
api.interceptors.response.use(
  // response => {
  //   if (response.data?.token) {
  //     accessTokenMemory = response.data.token;
  //     scheduleRefresh(response.data.token);
  //   }
  //   return response;
  // },
  response => {
    if (response.data?.token) {
      accessTokenMemory = response.data.token;
      hasAuthenticatedSession = true;
      scheduleRefresh(response.data.token);
    }

    if (response.config?.url?.includes("/api/auth/me")) {
      hasAuthenticatedSession = true;
    }

    return response;
  },
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isLoginPage()) {
        return Promise.reject(error);
      }

      const isAuthBootstrap =
        originalRequest.url?.includes("/api/auth/me") ||
        originalRequest.url?.includes("/api/auth/refresh");

      if (isAuthBootstrap && !hasAuthenticatedSession && !accessTokenMemory) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;
      const newToken = await refreshToken();
      if (!newToken) return Promise.reject(error);
      originalRequest.headers.Authorization = `Bearer ${newToken}`;
      return api(originalRequest);
    }

    return Promise.reject(error);
  }
);

export function get(path, params, config = {}) {
  return api.get(path, { params, ...config });
}

export function post(path, data, config = {}) {
  return api.post(path, data, { ...config });
}

export default api;